export default __webpack_public_path__ + "static/media/CricSense.802adf885c169bf5d7aa79d3d1ecfe7e.webp";